import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';
const eachStepDelay = 10000;

@Component({
  selector: 'app-progress-bar',
  imports: [CommonModule, AssetVersionPipe],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  @Input() totalSteps = 5;
  @Input() currentStep = 1;
  @Input() isCompleted = false;
  @Input() isError = false;
  @Input() stepLabels = [
    'Gathering recent data…',
    'Identifying key metrics…',
    'Generating insights…',
    'Preparing your analysis…',
    'Organizing results for review...',
    'Analysis completed'
  ];

  constructor() {
    setInterval(() => {
      this.currentStep = Math.min(this.currentStep + 1, this.totalSteps);
    }, eachStepDelay)
  }
}


